<div class="m-navbar">
  <div
    class="container-fluid d-flex justify-content-between align-items-center">
    <div class="m-n-brand m-left">
      <!-- Logo removed - now displayed in sidebar -->
    </div>
    <div class="ms-auto me-3 d-flex align-items-center">
      <app-user-menu></app-user-menu>
    </div>
  </div>
</div>
